export default class CareCostHourly {
    static fromData(data) {
        if (!data) {
            return;
        }

        let careCostHourly = new CareCostHourly();
        careCostHourly.id = data.id;
        careCostHourly.title = data.title;

        return careCostHourly;
    }
}
